var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LivePanelComponent"},[_c('b-alert',{class:{visible: _vm.libStatusOverall.length == 0},attrs:{"variant":_vm.variant,"show":""}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.libStatusOverall)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77dff231","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LivePanelComponent.vue
// module id = null
// module chunks = 